var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 571.44 289.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .accent {\n        fill: #603813;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M607.34,106.54C680.37,179.57,671,308,671,308s-116.5-2.57-189.53-75.6S377.42,72,412.18,37.24,534.31,33.51,607.34,106.54Z",
    transform: "translate(-99.95 -18.74)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M290.75,236.33C213.42,304.78,100,308,100,308s-4.56-136.5,72.78-205,166.43-94.1,199-57.3S368.09,167.88,290.75,236.33Z",
    transform: "translate(-99.95 -18.74)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M280.35,37.66S374.15,6.81,465.08,23.9,475,162,475,162L400,97.31,370,186l9.21-87.63Z",
    transform: "translate(-99.95 -18.74)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair1);
export default __webpack_public_path__ + "static/media/hair1.680b4e17.svg";
export { ForwardRef as ReactComponent };